import clsx from 'clsx';

export const Tag = ({ className = '', children }: React.PropsWithChildren<{ className?: string }>) => {
  return <div className={clsx('p-2 rounded bg-light-pink', className)}>{children}</div>;
};
